import { isMobileNative } from "./helpers";
import { logger } from "./logging";

export interface TrackEventData {
  className?: string;
  moduleNumber?: number;
  sessionNumber?: number;
  questionNumber?: number;
  timestamp?: number;
  trigger?: string;
}

/**
 * Track user behaviors.
 */
export function track(eventName: string, payload?: TrackEventData) {
  try {
    window.dataLayer?.push({
      event: eventName,
      mobileNative: isMobileNative(),
      ...payload,
    });
    logger.debug(`classroom:track`, { eventName, payload });
  } catch (error) {
    logger.error("Failed to push into dataLayer", error);
  }
}
